var map = {
	"./ion-action-sheet.entry.js": [
		260,
		5
	],
	"./ion-alert.entry.js": [
		261,
		6
	],
	"./ion-app_8.entry.js": [
		262,
		7
	],
	"./ion-avatar_3.entry.js": [
		263,
		17
	],
	"./ion-back-button.entry.js": [
		264,
		18
	],
	"./ion-backdrop.entry.js": [
		265,
		43
	],
	"./ion-button_2.entry.js": [
		266,
		19
	],
	"./ion-card_5.entry.js": [
		267,
		20
	],
	"./ion-checkbox.entry.js": [
		268,
		21
	],
	"./ion-chip.entry.js": [
		269,
		22
	],
	"./ion-col_3.entry.js": [
		270,
		44
	],
	"./ion-datetime_3.entry.js": [
		271,
		10
	],
	"./ion-fab_3.entry.js": [
		272,
		23
	],
	"./ion-img.entry.js": [
		273,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		274,
		46
	],
	"./ion-input.entry.js": [
		275,
		24
	],
	"./ion-item-option_3.entry.js": [
		276,
		25
	],
	"./ion-item_8.entry.js": [
		277,
		26
	],
	"./ion-loading.entry.js": [
		278,
		27
	],
	"./ion-menu_3.entry.js": [
		279,
		28
	],
	"./ion-modal.entry.js": [
		280,
		8
	],
	"./ion-nav_2.entry.js": [
		281,
		14
	],
	"./ion-popover.entry.js": [
		282,
		9
	],
	"./ion-progress-bar.entry.js": [
		283,
		29
	],
	"./ion-radio_2.entry.js": [
		284,
		30
	],
	"./ion-range.entry.js": [
		285,
		31
	],
	"./ion-refresher_2.entry.js": [
		286,
		11
	],
	"./ion-reorder_2.entry.js": [
		287,
		16
	],
	"./ion-ripple-effect.entry.js": [
		288,
		47
	],
	"./ion-route_4.entry.js": [
		289,
		32
	],
	"./ion-searchbar.entry.js": [
		290,
		33
	],
	"./ion-segment_2.entry.js": [
		291,
		34
	],
	"./ion-select_3.entry.js": [
		292,
		35
	],
	"./ion-slide_2.entry.js": [
		293,
		48
	],
	"./ion-spinner.entry.js": [
		294,
		13
	],
	"./ion-split-pane.entry.js": [
		295,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		296,
		36
	],
	"./ion-tab_2.entry.js": [
		297,
		15
	],
	"./ion-text.entry.js": [
		298,
		37
	],
	"./ion-textarea.entry.js": [
		299,
		38
	],
	"./ion-toast.entry.js": [
		300,
		39
	],
	"./ion-toggle.entry.js": [
		301,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		302,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 165;
module.exports = webpackAsyncContext;